import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageIssue } from '@/api/model/interfaces';

export default class DrawingPackageIssueOdata extends OdataManager<DrawingPackageIssue> {}
